module.exports = __webpack_public_path__ + "static/media/minus_with_circle_icon.97957125.svg";